import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Intelligence from './Intelligence';
import ZoneMarket from './ZoneMarket';
import ProjectAnalysis from './ProjectAnalysis';
import './ZoneMarket.css';

// Wraps the Intelligence page: adds a "Zone market" tab when the account has it
// enabled (the API answers 403 otherwise, and the page stays exactly as before).
const IntelligenceHub = ({ apiBase }) => {
  const [zones, setZones] = useState(null);
  const [tab, setTab] = useState('zone');

  useEffect(() => {
    axios.get(`${apiBase}/zone-market/zones`)
      .then((res) => setZones(res.data?.zones || []))
      .catch(() => setZones([]));
  }, [apiBase]);

  if (!zones || zones.length === 0) return <Intelligence apiBase={apiBase} />;

  return (
    <div>
      <div className="zm-tabs">
        <button className={tab === 'zone' ? 'zm-tab on' : 'zm-tab'} onClick={() => setTab('zone')}>Zone market</button>
        <button className={tab === 'project' ? 'zm-tab on' : 'zm-tab'} onClick={() => setTab('project')}>Project analysis</button>
      </div>
      {tab === 'zone' ? <ZoneMarket apiBase={apiBase} zones={zones} /> : <ProjectAnalysis apiBase={apiBase} />}
    </div>
  );
};

export default IntelligenceHub;
